import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { AdOriginType } from '../advert-fuse.js';
import { IAdvertFuseProps, StringWithAutocompleteOptions } from '../types.js';

const AdQueryO = {
  AdRequest: 'Ad Request',
  AdResponseNoAd: 'Ad Response No Ad',
  AdResponseHasAd: 'Ad Response Has Ad',
} as const;

export type AdQuery = (typeof AdQueryO)[keyof typeof AdQueryO];

const INTERSTITIAL_DATA_ONLY = false;

/** These comments are needed in production to advert site type and ad targeting values */
const AdLogger = (origin: StringWithAutocompleteOptions<AdOriginType> | undefined, fn: () => void) => {
  if (origin === 'adv-interstitial' || __BUILD_ENV__ === 'met') {
    fn();
  } else {
    if (!INTERSTITIAL_DATA_ONLY && origin !== 'adv-interstitial') {
      fn();
    }
  }
};

const getAdLoggerHeader = (type: AdQuery) => {
  if (type === AdQueryO.AdRequest) {
    return `${String.fromCodePoint(0x27a1)}`;
  }
  if (type === AdQueryO.AdResponseNoAd) {
    return `${String.fromCodePoint(0x26aa)}`;
  }
  if (type === AdQueryO.AdResponseHasAd) {
    return `${String.fromCodePoint(0x1f7e2)}`;
  }
};

export const AdLogic = ({
  type,
  fuseDataAttr,
  fuseTag,
  adUnitPath,
  origin,
}: {
  type: AdQuery;
  fuseDataAttr: Record<string, string>;
} & Pick<IAdvertFuseProps, 'fuseTag' | 'adUnitPath' | 'origin'>): void => {
  // const arrLogs = Object.keys(fuseDataAttr).map((k) => [k, fuseDataAttr[k]]) as [string, string][];
  const adPath = adUnitPath?.split('/').reverse()[0];
  const symbol = getAdLoggerHeader(type);
  return AdLogger(origin, () => {
    messageLog.ads(
      `${origin.replace('adv-', '')}: ${adPath} ${symbol}`,
      [`${type}`, `Origin: ${origin}`],
      ['fuseTag', fuseTag],
      ['adUnitPath', adUnitPath],
      ['Fuse Attributes', fuseDataAttr],
    );
  });
};
